/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */
/* eslint-disable @elastic/eui/prefer-css-attributes-for-eui-components */

import React from 'react'
import { useIntl } from 'react-intl'

import { EuiBetaBadge } from '@elastic/eui'

export const ElasticProductBadge: React.FC = () => {
  const { formatMessage } = useIntl()
  return (
    <EuiBetaBadge
      color='subdued'
      style={{ textTransform: 'uppercase' }}
      size='s'
      label={formatMessage({
        id: 'project.securityProjectFeatures.badge.elasticSiem.text',
        defaultMessage: 'ELASTIC SIEM',
      })}
    />
  )
}

export const ComplementProductBadge: React.FC = () => {
  const { formatMessage } = useIntl()
  return (
    <EuiBetaBadge
      color='subdued'
      style={{ textTransform: 'uppercase' }}
      size='s'
      label={formatMessage({
        id: 'project.securityProjectFeatures.badge.augment.text',
        defaultMessage: '3RD-PARTY SIEM COMPLEMENT',
      })}
    />
  )
}
